<template>
  <div @click="markerClickHandler">
    <div class="wrapper">
      <div :class="styles.colorAndOpacity(point, isSelected)" />
      <AppPopup v-if="isSelected" @close="close()">
        <PopupContent :point="point" :has-edit-permission="hasEditPermission" />
      </AppPopup>
      <div class="filler" />
    </div>
  </div>
</template>

<script>
import markerUIStyles from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Map/mapbox/markerUIStyles'
import { actions } from '@/vuex/modules/pointGroupOperation/constants'
import PopupContent from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Map/mapbox/PointGroupPopupContent'
import AppPopup from '@/components/App/AppPopup'

export default {
  name: 'MarkerUI',
  components: { AppPopup, PopupContent },
  props: { point: Object, isSelected: Boolean, hasEditPermission: Boolean },
  computed: {
    styles() {
      return markerUIStyles
    },
  },

  methods: {
    markerClickHandler(e) {
      e.stopPropagation()
      this.$store.dispatch(actions.SET_SELECTED_POINT, {
        data: this.point,
        moveMap: false,
      })
    },
    close() {
      this.$store.dispatch(actions.CLEAR_SELECTED_POINT)
    },
  },
}
</script>

<style scoped lang="scss">
.wrapper {
  position: relative;
}
.filler {
  position: absolute;
  top: -2px;
  left: -9px;
  background-color: transparent;
  width: 40px;
  height: 40px;
  cursor: move;
}
</style>
